function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 9.21655C28 8.4127 27.6774 7.64248 27.1045 7.07857L20.7892 0.862028C20.228 0.309616 19.4721 0 18.6847 0H7C5.34314 0 4 1.34315 4 3V29C4 30.6569 5.34315 32 7 32H25C26.6569 32 28 30.6569 28 29V9.21655Z",
  fill: "#DFDFE8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5 6.66667L20 0L28 8H22C21.1713 8 20.5 7.40333 20.5 6.66667ZM22 11H10C9.44772 11 9 11.4477 9 12V16C9 16.5523 9.44772 17 10 17H22C22.5523 17 23 16.5523 23 16V12C23 11.4477 22.5523 11 22 11ZM10 20C9.44772 20 9 20.4477 9 21C9 21.5523 9.44772 22 10 22H21C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H10ZM10 24C9.44772 24 9 24.4477 9 25C9 25.5523 9.44772 26 10 26H17C17.5523 26 18 25.5523 18 25C18 24.4477 17.5523 24 17 24H10Z",
  fill: "#9F9FBD"
});

function SvgTimelineSearchPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineSearchPost);
export default __webpack_public_path__ + "static/media/timeline_search_post.9035efb5.svg";
export { ForwardRef as ReactComponent };